import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IStatusMessage } from '../../../shared';
import { IShowErrors } from '../../../shared/errors-sidenav';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import * as fromStore from '../../store/indirect-rate-cost-center';
import * as fromStructure from '../../store/indirect-rate-structure';
@Component({
    selector: 'ef-indirect-rate-cost-center-container',
    templateUrl: './indirect-rate-cost-center-container.component.html',
    styleUrls: ['./indirect-rate-cost-center-container.component.scss'],
    standalone: false
})
export class IndirectRateCostCenterContainerComponent implements OnInit {
    costCenters$: Observable<fromStore.IndirectRateCostCenter[]>;
    rateStructures$: Observable<fromStructure.IndirectRateStructure[]>;
    showAdd$: Observable<boolean>;
    @Input() selectedError: IStatusMessage;
    @Output() public ShowError = new EventEmitter<IShowErrors>();
    constructor(
        private log: LoggingService,
        private store: Store<fromStore.State>
    ) {}

    ngOnInit() {
        this.store.dispatch(fromStore.getIndirectRateCostCenters());

        this.costCenters$ = this.store.pipe(
            select(fromStore.selectAll),
            map(x => clone(x))
        );
        this.rateStructures$ = this.store.pipe(select(fromStructure.selectAll));

        this.showAdd$ = this.rateStructures$.pipe(
            map(
                rates =>
                    rates.filter(x => x.Calctype === 'GAR').length > 1 ||
                    rates.filter(x => x.Calctype === 'FRR').length > 1
            )
        );
    }
    onSaveItem(items: fromStore.IndirectRateCostCenter[]) {
        this.log.verbose({
            type: 'IndirectRateCostCenterContainerComponent:onSaveItem',
            items
        });
        this.store.dispatch(
            fromStore.putIndirectRateCostCenters({
                indirectRateCostCenters: items
            })
        );
    }
}
